<template>
  <SkeletonLoader :class="computedClasses" data-testid="heading-display-loader">
    <div
      v-if="hasHead"
      class="heading-display-loader__head"
      data-testid="heading-head-loader"
    />
    <div
      v-if="hasTitle"
      class="heading-display-loader__title"
      data-testid="heading-title-loader"
    />
    <div
      v-if="hasSubTitle"
      class="heading-display-loader__sub-title"
      data-testid="heading-sub-title-loader"
    />
  </SkeletonLoader>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

import { SkeletonLoader } from '@warrenbrasil/nebraska-web';

@Component({
  components: {
    SkeletonLoader
  }
})
export default class HeadingDisplayLoader extends Vue {
  @Prop({ type: Boolean, default: true })
  readonly hasHead!: boolean;

  @Prop({ type: Boolean, default: true })
  readonly hasTitle!: boolean;

  @Prop({ type: Boolean, default: true })
  readonly hasSubTitle!: boolean;

  @Prop({ type: String, default: 'medium' })
  readonly size!: string;

  get computedClasses() {
    return {
      'heading-display-loader': true,
      'heading-display-loader--extra-small': this.size === 'extra-small',
      'heading-display-loader--small': this.size === 'small',
      'heading-display-loader--medium': this.size === 'medium',
      'heading-display-loader--large': this.size === 'large'
    };
  }
}
</script>

<style lang="less" scoped>
.heading-display-loader {
  width: 100%;

  &__head {
    border-radius: @size-radius-x100;
    margin-bottom: @size-spacing-x150;
  }

  &__title {
    border-radius: @size-radius-x100;
  }

  &__sub-title {
    border-radius: @size-radius-x100;
    margin-top: @size-spacing-x150;
  }

  &--extra-small {
    .heading-display-loader__head {
      width: 55%;
      height: 18px;
    }

    .heading-display-loader__title {
      width: 100%;
      height: 28px;
    }

    .heading-display-loader__sub-title {
      width: 45%;
      height: 18px;
    }
  }

  &--small {
    .heading-display-loader__head {
      width: 55%;
      height: 24px;
    }

    .heading-display-loader__title {
      width: 100%;
      height: 32px;
    }

    .heading-display-loader__sub-title {
      width: 45%;
      height: 24px;
    }
  }

  &--medium {
    .heading-display-loader__head {
      width: 50%;
      height: 26px;
    }

    .heading-display-loader__title {
      width: 100%;
      height: 48px;
    }

    .heading-display-loader__sub-title {
      width: 45%;
      height: 26px;
    }
  }

  &--large {
    .heading-display-loader__head {
      width: 45%;
      height: 28px;
    }

    .heading-display-loader__title {
      width: 100%;
      height: 56px;
    }

    .heading-display-loader__sub-title {
      width: 40%;
      height: 28px;
    }
  }
}
</style>
